// import React, {useState, useEffect} from 'react';
// import {List, ListItem, ListItemText, Divider} from '@mui/material';
// import Collapse from '@mui/material/Collapse';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import {Link} from 'react-router-dom';
// import {EvaluarPermiso} from '../../Genericos/Generales';

// const Cuenta = props => {
//   const classes = props.classes;
//   const sesionUsuario = props.sesionUsuario;

//   const [notas, setNotas] = useState (false);
//   const [difusiones, setDifusiones] = useState (false);
//   const [misNotas, setMisNotas] = useState (false);
//   const [nuevaNota, setNuevaNota] = useState (false);
//   const [nuevaDifusion, setNuevaDifusion] = useState (false);
//   const [notasEnviadas, setNotasEnviadas] = useState (false);

//   useEffect (() => {
//     VerificarPermisos (
//       sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//     );
//   }, [sesionUsuario]);

//   const VerificarPermisos = arrPermisos => {
//     setNotas (EvaluarPermiso (arrPermisos, '/notas'));
//     setDifusiones (EvaluarPermiso (arrPermisos, '/difusiones'));
//     setMisNotas (EvaluarPermiso (arrPermisos, '/misNotas'));
//     setNuevaNota (EvaluarPermiso (arrPermisos, '/nuevaNota'));
//     setNuevaDifusion (EvaluarPermiso (arrPermisos, '/nuevaDifusion'));
//     setNotasEnviadas (EvaluarPermiso (arrPermisos, '/notasEnviadas'));
//   };

//   const [openNotas, setOpenNotas] = useState (false);
//   const handleOpenNotas = () => {
//     setOpenNotas (!openNotas);
//   };

//   return (
//     <React.Fragment>
//       {notas
//         ? <List>
//             <ListItem onClick={handleOpenNotas}>
//               <i className="material-icons">note</i>
//               <ListItemText
//                 classes={{primary: classes.listItemText}}
//                 primary="Notas"
//               />
//               {openNotas ? <ExpandLess /> : <ExpandMore />}
//             </ListItem>

//             <Collapse in={openNotas} timeout="auto" unmountOnExit>
//               <List component="div" disablePadding>
//                 {difusiones
//                   ? <ListItem
//                       component={Link}
//                       button
//                       to="/difusiones"
//                       className={classes.listItemText}
//                     >
//                       <i notranslate="true" className="material-icons">
//                         record_voice_over
//                       </i>
//                       <ListItemText primary="Difusiones" />
//                     </ListItem>
//                   : null}
//                 {misNotas
//                   ? <ListItem
//                       component={Link}
//                       button
//                       to="/misNotas"
//                       className={classes.listItemText}
//                     >
//                       <i notranslate="true" className="material-icons">
//                         inbox
//                       </i>
//                       <ListItemText primary="Mis Notas" />
//                     </ListItem>
//                   : null}
//                 {nuevaNota
//                   ? <ListItem
//                       component={Link}
//                       button
//                       to="/nuevaNota"
//                       className={classes.listItemText}
//                     >
//                       <i notranslate="true" className="material-icons">
//                         connect_without_contact
//                       </i>
//                       <ListItemText primary="Nueva Nota" />
//                     </ListItem>
//                   : null}
//                 {notasEnviadas
//                   ? <ListItem
//                       component={Link}
//                       button
//                       to="/notasEnviadas"
//                       className={classes.listItemText}
//                     >
//                       <i notranslate="true" className="material-icons">
//                         forward_to_inbox
//                       </i>
//                       <ListItemText primary="Notas Enviadas" />
//                     </ListItem>
//                   : null}
//                 {nuevaDifusion
//                   ? <ListItem
//                       component={Link}
//                       button
//                       to="/nuevaDifusion"
//                       className={classes.listItemText}
//                     >
//                       <i notranslate="true" className="material-icons">
//                         sms_failed
//                       </i>
//                       <ListItemText primary="Nueva Difusion" />
//                     </ListItem>
//                   : null}
//               </List>
//             </Collapse>
//           </List>
//         : null}
//       {notas ? <Divider /> : null}
//     </React.Fragment>
//   );
// };

// export default Cuenta;
import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, ListItemIcon, Collapse } from '@mui/material';
import NoteIcon from '@mui/icons-material/Note';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import InboxIcon from '@mui/icons-material/Inbox';
import SendIcon from '@mui/icons-material/Send';
import AddCommentIcon from '@mui/icons-material/AddComment';
import CampaignIcon from '@mui/icons-material/Campaign';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';
import { EvaluarPermiso } from '../../Genericos/Generales';
import { menuItemStyles } from '../../Tools/MenuItemStyles';

const Notas = ({ sesionUsuario }) => {
  const [notas, setNotas] = useState(false);
  const [difusiones, setDifusiones] = useState(false);
  const [misNotas, setMisNotas] = useState(false);
  const [nuevaNota, setNuevaNota] = useState(false);
  const [nuevaDifusion, setNuevaDifusion] = useState(false);
  const [notasEnviadas, setNotasEnviadas] = useState(false);
  const [openNotas, setOpenNotas] = useState(false);

  useEffect(() => {
    const permisos = sesionUsuario.usuario.pantallasUsuario.listaPantallasRol;
    setNotas(EvaluarPermiso(permisos, '/notas'));
    setDifusiones(EvaluarPermiso(permisos, '/difusiones'));
    setMisNotas(EvaluarPermiso(permisos, '/misNotas'));
    setNuevaNota(EvaluarPermiso(permisos, '/nuevaNota'));
    setNuevaDifusion(EvaluarPermiso(permisos, '/nuevaDifusion'));
    setNotasEnviadas(EvaluarPermiso(permisos, '/notasEnviadas'));
  }, [sesionUsuario]);

  const handleOpenNotas = () => {
    setOpenNotas(!openNotas);
  };

  return (
    <>
      {notas && (
        <>
          <ListItem
            button
            onClick={handleOpenNotas}
            sx={menuItemStyles.expandableHeader}
          >
            <ListItemIcon sx={menuItemStyles.menuIcon}>
              <NoteIcon />
            </ListItemIcon>
            <ListItemText
              primary="Notas"
              sx={menuItemStyles.menuText}
            />
            {openNotas ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openNotas} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {difusiones && (
                <ListItem
                  button
                  component={Link}
                  to="/difusiones"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <RecordVoiceOverIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Difusiones"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {misNotas && (
                <ListItem
                  button
                  component={Link}
                  to="/misNotas"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <InboxIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Notas Recibidas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {nuevaNota && (
                <ListItem
                  button
                  component={Link}
                  to="/nuevaNota"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <AddCommentIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Nueva Nota"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {notasEnviadas && (
                <ListItem
                  button
                  component={Link}
                  to="/notasEnviadas"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <SendIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Notas Enviadas"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {nuevaDifusion && (
                <ListItem
                  button
                  component={Link}
                  to="/nuevaDifusion"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <CampaignIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Nueva Difusión"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
};

export default Notas;
